//removes any (/) and (-) from a string provided
//if the string is /my-activity you will get  myactivity as a result
var stripsTagsAndSlashes = function (str) { return str.replace(/[\/-]+/g, ''); };
export default stripsTagsAndSlashes;
